"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// English (Template)
var strings = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: 'முன்பு',
  suffixFromNow: 'இப்போது முதல்',
  seconds: 'ஒரு நிமிடத்திற்கும் குறைவாக',
  minute: 'ஒரு நிமிடம்',
  minutes: '%d நிமிடங்கள்',
  hour: 'சுமார் ஒரு மணிநேரம்',
  hours: 'சுமார் %d மணிநேரம் ',
  day: 'ஒரு நாள்',
  days: '%d நாட்கள்',
  month: 'சுமார் ஒரு மாதம்',
  months: '%d மாதங்கள்',
  year: 'சுமார் ஒரு வருடம்',
  years: '%d ஆண்டுகள்',
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;